import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BankTab',
  props: {
    employee: {},
    data: {}
  },
  setup(__props: any) {

    const props = __props;

    const values = computed(() => {
        return [
            { name: 'bank_reg', group: 'bank', key: 'bank' },
            { name: 'bank_account', group: 'bank', key: 'bank' },
        ];
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmployeeChangesGroup, {
    data: _ctx.data,
    values: values.value,
    employee: _ctx.employee
  }, null, 8, ["data", "values", "employee"]))
}
}

})